import { getBlogsApiCall } from "@/api/Blog";
import Picture from "@/components/common/picture/Picture";
import { ApiResponseType, BlogType } from "@/types";
import { dehydrate, QueryClient, useQuery } from "@tanstack/react-query";
import Link from "next/link";
import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export default function BlogSwiper() {
  const { data: blogsData } = useQuery<ApiResponseType<BlogType>>({
    queryKey: ["getBlogsApiCall"],
    queryFn: () => getBlogsApiCall(),
  });

  return (
    <>
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        breakpoints={{
          640: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 1.8,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 2.3,
            spaceBetween: 40,
          },
          1450: {
            slidesPerView: 2.6,
            spaceBetween: 20,
          },
          1640: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
        modules={[Navigation]}
        navigation={{
          prevEl: ".blog_left-btn",
          nextEl: ".blog_right-btn",
        }}
        className="blog_items_swiper"
      >
        {blogsData &&
          blogsData.data.map((singleBlogData, index) => {
            return (
              <SwiperSlide
                className="blog_item lg:w-[520px] min-w-[343px] group/blog_item transition-all duration-300 max-w-[520px]"
                key={index}
              >
                <Link href={`/blogPage/${singleBlogData.id}`}>
                  <div className="blog_item-img lg:w-[520px] lg:h-[380px] min-w-[343px] h-[343px] bg-disable-text-color overflow-hidden">
                    <Picture
                      alt="blog-image"
                      src={singleBlogData.attributes.image.data?.attributes.url ?? ""}
                      priority
                      width={520}
                      height={380}
                      className="object-cover w-full h-full"
                    />
                  </div>
                  <div className="blog_item-content flex flex-col lg:w-[520px] mt-7">
                    <p className="blog_item-date text-transparent group-hover/blog_item:text-placeholder-text-color text-center transition-all duration-300">
                      {singleBlogData.attributes.title}
                    </p>
                  </div>
                </Link>
              </SwiperSlide>
            );
          })}
      </Swiper>
      <div className="about_nav-btn-wrapper flex items-center justify-center gap-5 2xl:mt-10 mt-[20px]">
        <div className="blog_left-btn w-[60px] h-[60px] bg-white border border-disable-color rounded-full flex justify-center items-center cursor-pointer">
          <Picture
            src={"/icons/Icon name=prev arrow.svg"}
            alt={"left-btn"}
            width={24}
            height={24}
          />
        </div>
        <div className="blog_right-btn w-[60px] h-[60px] bg-white border border-disable-color rounded-full flex justify-center items-center cursor-pointer">
          <Picture
            src={"/icons/Icon name=next arrow.svg"}
            alt={"right-btn"}
            width={24}
            height={24}
          />
        </div>
      </div>
    </>
  );
}
